import { useCallback, useState } from 'react';

import { salvarEmpresaCertificado } from '../../../../api/certificado';

export default function useCadastroCertificadoModule({ context, setFlashMessage, fecharDialog, atualizar }) {
    const [loading, setLoading] = useState(false);
    const empresaId = context.empresaId;
    const validar = useCallback(
        ({ arquivo, senha, finalidade, ambiente, funcao }) => {
            if (!empresaId) {
                setFlashMessage?.('Salve a empresa antes de cadastrar o certificado.', 'warning');

                return false;
            }

            // Cadastro
            if (funcao === 'Cadastrar') {
                if (!arquivo) {
                    setFlashMessage?.('Selecione o certificado A1.', 'warning');

                    return false;
                }

                const extensao = String(arquivo.name || '')
                    .toLowerCase()
                    .split('.')
                    .pop();

                if (!['pfx', 'p12'].includes(extensao)) {
                    setFlashMessage?.('Selecione um arquivo .pfx ou .p12.', 'warning');

                    return false;
                }

                if (!senha) {
                    setFlashMessage?.('Informe a senha do certificado.', 'warning');

                    return false;
                }
            }

            // Edição
            if (funcao === 'Editar' && arquivo) {
                const extensao = String(arquivo.name || '')
                    .toLowerCase()
                    .split('.')
                    .pop();

                if (!['pfx', 'p12'].includes(extensao)) {
                    setFlashMessage?.('Selecione um arquivo .pfx ou .p12.', 'warning');

                    return false;
                }

                if (!senha) {
                    setFlashMessage?.('Informe a senha do novo certificado.', 'warning');

                    return false;
                }
            }

            // Deletar
            if (funcao === 'Deletar') {
                return true;
            }

            if (!finalidade) {
                setFlashMessage?.('Informe a finalidade do certificado.', 'warning');

                return false;
            }

            if (!ambiente) {
                setFlashMessage?.('Informe o ambiente do certificado.', 'warning');

                return false;
            }

            return true;
        },
        [empresaId, setFlashMessage]
    );

    const montarFormData = useCallback(
        ({ arquivo, senha, finalidade, ambiente, modoEdicao, selected }) => {
            const formData = new FormData();

            formData.append('empresaId', Number(empresaId));

            if (selected?.uuid) {
                formData.append('uuid', selected.uuid);
            }

            formData.append('finalidade', finalidade);
            formData.append('ambiente', ambiente);

            if (senha) {
                formData.append('senha', senha);
            }

            if (arquivo) {
                formData.append('certificado', arquivo);
            }

            formData.append('funcao', selected?.funcao || 'Cadastrar');

            return formData;
        },
        [empresaId]
    );

    const salvar = useCallback(
        async (dadosCertificado) => {
            if (!validar(dadosCertificado)) return null;

            setLoading(true);

            try {
                const formData = montarFormData(dadosCertificado);

                const resultado = await salvarEmpresaCertificado(formData);

                const mensagem =
                    resultado?.message ||
                    (dadosCertificado.modoEdicao ? 'Certificado atualizado com sucesso!' : 'Certificado cadastrado com sucesso!');

                setFlashMessage?.(mensagem, resultado?.type || 'success');

                await atualizar?.();
                fecharDialog?.();

                return resultado;
            } catch (error) {
                console.error('Erro ao cadastrar certificado digital:', error);

                const payload = error?.response?.data;

                setFlashMessage?.(
                    payload?.message || error?.message || 'Erro ao cadastrar certificado.',
                    payload?.type || 'error'
                );

                return null;
            } finally {
                setLoading(false);
            }
        },
        [validar, montarFormData, setFlashMessage, atualizar, fecharDialog]
    );

    return {
        state: {
            loading,
        },

        actions: {
            salvar,
        },
    };
}
